import { useContext } from 'react';

import { DossierApi, DemandeurApi } from '../../../openApi/ApiSign';

import L2DApiContext from '../L2DApiContext';

export const useSignService = () => {
    const context = useContext(L2DApiContext);

    if (!context) {
        throw new Error('useL2DApi must be used within a L2DApiProvider');
    }

    if (!context.sign) {
        throw new Error('Sign service is not registered in L2DApiProvider');
    }

    const { apis, slices, thunks, fetchItems, getItems, reducer } = context.sign;

    return {
        reducer,

        dossierApi: apis.dossierApi as DossierApi,
        demandeurApi: apis.demandeurApi as DemandeurApi,

        dossierSignatureSlice: slices.dossierSignatureSlice,
        demandeurSignatureSlice: slices.demandeurSignatureSlice,

        dossierSignatureDataSourcesThunks: thunks.dossierSignatureDataSourcesThunks,
        demandeurSignatureDataSourcesThunks: thunks.demandeurSignatureDataSourcesThunks,

        getDossierSignature: fetchItems.getDossierSignature,
        getDemandeurSignature: fetchItems.getDemandeurSignature,

        selectDossierSignature: getItems.selectDossierSignature,
        selectDemandeurSignature: getItems.selectDemandeurSignature,

        // Constants
        sliceNames: {
            dossierSignature: 'dossierSignature',
            demandeurSignature: 'demandeurSignature',
        },
    };
};
